import { Switch } from 'components/Inputs/Switch';
import { TextInput } from 'components/Inputs/TextInput';
import React from 'react';
import { ICompanyAccess } from 'types/Company';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, Grid, IconButton, Tooltip } from '@mui/material';

type Props = { index: number; onDeleteClick: () => void } & ICompanyAccess;

export const AccessRow: React.FC<Props> = ({ index, onDeleteClick }) => {
  const getFieldName = (fieldName: string) =>
    `users.${index}.${fieldName}` as any;

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextInput
          required
          name={getFieldName('name')}
          id="name"
          label="NOME DO COLABORADOR"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextInput
          required
          name={getFieldName('email')}
          id="email"
          label="E-MAIL CORPORATIVO"
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <Box height="100%" display="flex" alignItems="center">
          <Switch name={getFieldName('isSuperUser')} label="Super Usuário" />
        </Box>
      </Grid>

      <Grid item xs={12} md={1}>
        <Box height="100%" display="flex" alignItems="center">
          <Tooltip title="Deletar">
            <IconButton
              aria-label="Deletar"
              onClick={onDeleteClick}
              size="large"
            >
              <DeleteOutlineIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
  );
};
